import React from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { RowContainer, LeftContent, RightContent } from './ShimmerRecentTransactionCard.styles';
import { skeletonProps } from '../Shimmer.types';

const TransactionRowSkeleton = () => (
  <RowContainer>
    <Skeleton circle width={44} height={44} {...skeletonProps} />
    <LeftContent>
      <Skeleton width={140} height={16} borderRadius={4} {...skeletonProps} />
      <Skeleton width={100} height={12} borderRadius={4} {...skeletonProps} />
      <Skeleton width={80} height={12} borderRadius={4} {...skeletonProps} />
    </LeftContent>
    <RightContent>
      <Skeleton width={120} height={16} borderRadius={4} {...skeletonProps} />
      <Skeleton width={80} height={13} borderRadius={4} {...skeletonProps} />
      <Skeleton width={90} height={13} borderRadius={4} {...skeletonProps} />
    </RightContent>
  </RowContainer>
);

export const ShimmerRecentTransactionCard = () => (
  <>
    <TransactionRowSkeleton />
    <TransactionRowSkeleton />
  </>
);
